import {register} from '@shopify/theme-sections'
import '../../styles/sections/section-tabbed-calculator.scss'

export default register(
    `section-tabbed-calculator`,
    {
        onLoad() {
            const wrapper = document.querySelector(`.tabbed-calculator-wrapper`)
            let buttons = wrapper.querySelectorAll(`.tab-label`)
            let tabs = wrapper.querySelectorAll(`.calculator-tab`)

            buttons.forEach(button => {
                button.addEventListener(`click`, e => {
                    if (!(button.classList.contains(`active`))) {
                        wrapper.querySelector(`.tab-label.active`).classList.remove(`active`)
                        button.classList.add(`active`)
                        tabs.forEach(tab => {
                            if (tab.id !== button.dataset.target) {
                                tab.classList.remove(`active`)
                            } else {
                                tab.classList.add(`active`)
                            }
                        })

                    }
                })
            })
        },
        onUnload() {}
    }
)
